export default __webpack_public_path__ + "static/media/investorPortal.090ea78c.png";